import { AlertTriangle } from 'lucide-react';

/**
 * UnsavedWarningDialog — Shown when user tries to navigate away with unsaved edits.
 * Always shows (not affected by "Don't show again" preference).
 */
export default function UnsavedWarningDialog({ onStay, onLeave }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onStay}>
      <div
        className="bg-white rounded-xl shadow-2xl max-w-sm w-full mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-3 mb-5">
          <div className="p-2 bg-red-50 rounded-lg shrink-0">
            <AlertTriangle size={20} className="text-red-500" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Unsaved Changes</h3>
            <p className="text-sm text-gray-600 mt-1">
              You have unsaved edits. Leave without saving?
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onStay}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Stay
          </button>
          <button
            onClick={onLeave}
            className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
}
